import React from 'react'
import Routes from 'routes'
import { Link } from 'react-router-dom'
import { withApp } from 'helpers'
import logoSvg from 'assets/img/logo-schiphol.svg'
import logoBlackSvg from 'assets/img/logo-schiphol-black.svg'
import './AppLogo.css'

const AppLogo = props => {
  const logo = props.app.location && props.app.location.label === 'intro' ? logoBlackSvg : logoSvg

  return (
    <div className="App-logo">
      <Link to={Routes.to('home')}><img src={logo} alt="Schiphol" /></Link>
    </div>
  )
}

export default withApp(AppLogo)


// WEBPACK FOOTER //
// ./src/components/layout/header/logo/AppLogo.js